import React from 'react'
import StandardPageLayout from '@/components/StandardPageLayout'
import { Headline, Container, RichText, VideoPlayer } from '@/components/common'
const { LayoutSection } = StandardPageLayout

class OurFirm extends React.PureComponent {
	render() {
		const layoutConfig = {
			pageTitle: 'Our Firm',
			masthead: (
				<StandardPageLayout.Masthead title="Our Firm" backgroundImage={require('./img/masthead_bg.jpg')} />
			)
		}

		return (
			<StandardPageLayout {...layoutConfig}>
				<Container>
					<LayoutSection
						headline={
							<Headline tag="h2" theme="hd-1">
								A proud history of exceptional service
							</Headline>
						}
					>
						<RichText>
							<p>
								At Ropers Majeski, we pride ourselves on the results we deliver and the value we add to
								every client relationship. Our lawyers advise clients on complex litigation and
								sophisticated business transactions in a broad range of industries. We solve problems,
								structure deals, and represent our clients' best interests in everything we do.
							</p>
						</RichText>
					</LayoutSection>
					<LayoutSection>
						<VideoPlayer.AWS
							asset="Ropers_Majeski_Strengths_20250206_web"
							poster="Ropers_Majeski_Strengths_I_web"
						/>
					</LayoutSection>
					<LayoutSection
						headline={
							<Headline tag="h2" theme="hd-2">
								Representing our clients in their critical deals and complex cases
							</Headline>
						}
					>
						<RichText>
							<p>
								For more than 75 years, Ropers Majeski has served businesses and individuals facing
								legal challenges. Our skilled lawyers provide comprehensive legal counsel in core areas,
								including litigation, corporate transactions, employment, bankruptcy, intellectual
								property, and trials. With more than 100 lawyers across 8 offices worldwide, including
								strategically located offices in Los Angeles, Las Vegas, Menlo Park, Minneapolis, San
								Jose, Seattle, and New York, we deliver accessible and responsive representation
								nationwide.
							</p>
							<p>
								We also advise multinational businesses and maintain international offices in Paris and
								an affiliate office in Hong Kong. Our global reach allows us to support clients with
								international operations, navigate complex cross-border legal matters, and stay informed
								about developments that may impact your business.
							</p>
						</RichText>
					</LayoutSection>
				</Container>
			</StandardPageLayout>
		)
	}
}

export const routeConfig = {
	path: '/our-firm',
	exact: true
}

export default OurFirm
